package fr.labodoc.healthProfessional.webApp.pages.learnedSocieties

import fr.labodoc.healthProfessional.webApp.App
import fr.labodoc.healthProfessional.webApp.components.LabodocSelectCheckboxInput
import fr.labodoc.healthProfessional.webApp.components.hr
import fr.labodoc.healthProfessional.webApp.components.labodocSpinner
import fr.labodoc.require
import io.kvision.core.Container
import io.kvision.core.onChange
import io.kvision.form.check.checkBox
import io.kvision.html.*
import io.kvision.panel.SimplePanel
import io.kvision.state.bind
import io.kvision.toast.Toast
import kotlinx.coroutines.launch
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

class LearnedSocietiesPage : SimplePanel(), KoinComponent {
  private val viewModel: LearnedSocietiesPageViewModel by inject()

  init {
    id = "page-learned-societies"
    require("./css/pages/learnedSocieties/learned-societies.css")

    App.Companion.scope.launch {
      viewModel.events.collect { event ->
        when (event) {
          is LearnedSocietiesPageViewModel.Event.UpdateFavoriteStatusFailed -> {
            Toast.danger("Une erreur s'est produite en changeant le statut favori de la société savante ${event.learnedSociety.name}")
          }
        }
      }
    }

    div(className = "page-width") {
      header {
        div(className = "title") {
          h1 {
            content = "Les Sociétés Savantes, Clubs et Associations"
          }
        }

        filters()
      }

      div(className = "container").bind(viewModel.learnedSocietiesListState) { learnedSocietiesListState ->
        when (learnedSocietiesListState) {
          is LearnedSocietiesPageViewModel.LearnedSocietiesList.Loading -> {
            labodocSpinner()
          }

          is LearnedSocietiesPageViewModel.LearnedSocietiesList.Error -> {
            Toast.danger("Impossible de récupérer la liste des sociétés savantes")
          }

          is LearnedSocietiesPageViewModel.LearnedSocietiesList.Loaded -> {
            div(className = "cards") {
              learnedSocietiesListState.learnedSocieties.forEach { learnedSociety ->
                link(label = "", url = learnedSociety.websiteUrl, target = "_blank") {
                  card(learnedSociety)
                }
              }
            }
          }
        }
      }
    }
  }

  private fun Container.filters(): Container {
    return div(className = "filters") {
      val medicalSpecialitiesFilter = LabodocSelectCheckboxInput {
        onChange {
          viewModel.updateFilter(
            LearnedSocietiesPageViewModel.Filter.MedicalSpecialities(
              this.values?.map { it }?.toSet().orEmpty()
            )
          )
        }
      }.bind(viewModel.medicalSpecialityFilterOptions, removeChildren = false) { medicalSpecialityFilterOptions ->
        options = medicalSpecialityFilterOptions
      }.bind(viewModel.filter, removeChildren = false) { filter ->
        when (filter) {
          is LearnedSocietiesPageViewModel.Filter.MedicalSpecialities -> this.show()
          else -> this.hide()
        }
      }

      div(className = "buttons") {
        button("Ma spécialité") {
          onClick { viewModel.updateFilter(LearnedSocietiesPageViewModel.Filter.MySpeciality) }
        }.bind(viewModel.filter) { filter ->
          if (filter is LearnedSocietiesPageViewModel.Filter.MySpeciality) addCssClass("active") else removeCssClass("active")
        }

        button("Favoris") {
          onClick { viewModel.updateFilter(LearnedSocietiesPageViewModel.Filter.Favorites) }
        }.bind(viewModel.filter) { filter ->
          if (filter is LearnedSocietiesPageViewModel.Filter.Favorites) addCssClass("active") else removeCssClass("active")
        }

        button("Tous") {
          onClick { viewModel.updateFilter(LearnedSocietiesPageViewModel.Filter.All) }
        }.bind(viewModel.filter) { filter ->
          if (filter is LearnedSocietiesPageViewModel.Filter.All) addCssClass("active") else removeCssClass("active")
        }

        button("Spécialité") {
          onClick {
            viewModel.updateFilter(LearnedSocietiesPageViewModel.Filter.MedicalSpecialities(medicalSpecialitiesFilter.values?.map { it }?.toSet().orEmpty()))
          }
        }.bind(viewModel.filter) { filter ->
          if (filter is LearnedSocietiesPageViewModel.Filter.MedicalSpecialities) addCssClass("active") else removeCssClass("active")
        }
      }

      add(medicalSpecialitiesFilter)
    }
  }

  private fun Container.card(learnedSociety: LearnedSocietiesPageViewModel.LearnedSociety): Container {
    return div(className = "card") {
      header {
        image(learnedSociety.logoUrl, learnedSociety.name)

        checkBox {
          addCssClass("favorite")
          value = learnedSociety.favorite

          onChange {
            value = !value
            viewModel.updateFavoriteStatus(learnedSociety)
          }

          onClick { it.stopPropagation() }
        }
      }

      hr()

      p(learnedSociety.name)
    }
  }
}

fun Container.learnedSocietiesPage(): LearnedSocietiesPage {
  val learnedSocietiesPage = LearnedSocietiesPage()

  this.add(learnedSocietiesPage)
  return learnedSocietiesPage
}
